import graphql__de0f4c01352a330a5b2f from "./__generated__/PageSectionSidebarAnalyticsDataList_pageSection.graphql.js";import { createFragmentContainer } from "react-relay";
import { graphql } from "react-relay";

import PageSectionSidebarBlock from "./PageSectionSidebarBlock";
import AnalyticsDatumCardRow from "../AnalyticsDatum/AnalyticsDatumCardRow";

const PageSectionSidebarAnalyticsDataList = props => {
  const { title, description, analyticsData } = props.pageSection;

  return (
    <PageSectionSidebarBlock
      title={title}
      description={description}
      iconClassName="icon-activity"
    >
      <div className="analytics-data-list box padding-sm">
        {analyticsData.map(analyticsDatum => (
          <AnalyticsDatumCardRow
            key={analyticsDatum.id}
            analyticsDatum={analyticsDatum}
          />
        ))}
      </div>
    </PageSectionSidebarBlock>
  );
};

export default createFragmentContainer(PageSectionSidebarAnalyticsDataList, {
  pageSection: graphql__de0f4c01352a330a5b2f
});
